module.exports = __webpack_public_path__ + "static/media/plus-icon-taskprops.77538893.svg";